// AboutProduct.jsx

import React from "react";
import "../AboutPage/Css/AboutProduct.css";

import {
  MdSolarPower,
  MdOutlineLightMode,
  MdOutlineSecurity,
  MdOutlineWaterDrop,
} from "react-icons/md";

import {
  FaSolarPanel,
  FaStreetView,
  FaVideo,
  FaLightbulb,
} from "react-icons/fa";

const products = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clip-path="url(#clip0_814_2141)">
          <path
            d="M41.6668 66.6667H79.8901L73.5901 42.8667C72.6235 39.2133 69.3101 36.6667 65.5334 36.6667H14.5635C10.7868 36.6667 7.47679 39.2167 6.50679 42.8667L0.206787 66.6667H38.3335V76.6667H20.0001V80H60.0001V76.6667H41.6668V66.6667ZM50.1968 53.3333L51.4468 63.3333H28.5568L29.8068 53.3333H50.1968ZM30.2235 50L31.4735 40H48.5301L49.7801 50H30.2235ZM54.8068 63.3333L53.5568 53.3333H72.9135L75.5601 63.3333H54.8068ZM70.3701 43.72L72.0335 50H53.1401L51.8901 40H65.5368C67.8035 40 69.7901 41.53 70.3701 43.72ZM9.73345 43.72C10.3135 41.53 12.3035 40 14.5668 40H28.1135L26.8635 50H8.06679L9.73012 43.72H9.73345ZM7.18679 53.3333H26.4468L25.1968 63.3333H4.53679L7.18679 53.3333ZM26.6701 30H13.3368V26.6667H23.3368C23.3368 22.6733 24.8068 19.0533 27.1568 16.18L19.9668 8.99L22.3235 6.63333L29.5135 13.8233C31.9768 11.8067 35.0001 10.5067 38.3368 10.17V0H41.6701V10.17C45.0068 10.5067 48.0301 11.8067 50.4901 13.8233L57.6801 6.63333L60.0368 8.99L52.8468 16.18C55.1968 19.0533 56.6668 22.6733 56.6668 26.6667H66.6668V30H53.3335V26.6667C53.3335 19.3133 47.3535 13.3333 40.0001 13.3333C32.6468 13.3333 26.6668 19.3133 26.6668 26.6667V30H26.6701Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_814_2141">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Solar Off-Grid System",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <path
          d="M38.3318 66.6667H79.8901L73.5901 42.8667C72.6235 39.2133 69.3101 36.6667 65.5334 36.6667H14.5635C10.7868 36.6667 7.47679 39.2167 6.50679 42.8667L0.206787 66.6667H38.3318L38.3335 76.6667H20.0001H54.8068H60.0001H38.3335L38.3318 66.6667ZM50.1968 53.3333L51.4468 63.3333H28.5568L29.8068 53.3333H50.1968ZM30.2235 50L31.4735 40H48.5301L49.7801 50H30.2235ZM54.8068 63.3333L53.5568 53.3333H72.9135L75.5601 63.3333H54.8068ZM70.3701 43.72L72.0335 50H53.1401L51.8901 40H65.5368C67.8035 40 69.7901 41.53 70.3701 43.72ZM9.73345 43.72C10.3135 41.53 12.3035 40 14.5668 40H28.1135L26.8635 50H8.06679L9.73012 43.72H9.73345ZM7.18679 53.3333H26.4468L25.1968 63.3333H4.53679L7.18679 53.3333ZM26.6701 30H13.3368V26.6667H23.3368C23.3368 22.6733 24.8068 19.0533 27.1568 16.18L19.9668 8.99L22.3235 6.63333L29.5135 13.8233C31.9768 11.8067 35.0001 10.5067 38.3368 10.17V0H41.6701V10.17C45.0068 10.5067 48.0301 11.8067 50.4901 13.8233L57.6801 6.63333L60.0368 8.99L52.8468 16.18C55.1968 19.0533 56.6668 22.6733 56.6668 26.6667H66.6668V30H53.3335V26.6667C53.3335 19.3133 47.3535 13.3333 40.0001 13.3333C32.6468 13.3333 26.6668 19.3133 26.6668 26.6667V30H26.6701Z"
          fill="white"
        />
      </svg>
    ),
    title: "Solar Hybrid Systems",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
      >
        <path
          d="M50 4C45.589 4 42 7.589 42 12C42 16.411 45.589 20 50 20C54.411 20 58 16.411 58 12C58 7.589 54.411 4 50 4ZM50 18C46.691 18 44 15.309 44 12C44 8.691 46.691 6 50 6C53.309 6 56 8.691 56 12C56 15.309 53.309 18 50 18Z"
          fill="black"
        />
        <path
          d="M57.997 3.054C55.456 0.78 52.038 -0.3 48.622 0.077C43.357 0.665 38.952 4.879 38.147 10.098C37.382 15.052 39.721 19.91 44 22.383V33C44 35.045 45.237 36.802 47 37.576V42C45.346 42 44 43.346 44 45C44 46.553 45.19 47.818 46.703 47.97C45.581 52.617 41.38 56 36.5 56C30.71 56 26 51.29 26 45.5V39.816C27.161 39.402 28 38.302 28 37V35H27.969C29.194 34.088 30 32.641 30 31V5C30 2.243 27.757 0 25 0H5C2.243 0 0 2.243 0 5V31C0 33.757 2.243 36 5 36H6V38.184C4.838 38.598 4 39.698 4 41V44H0V50H4V53C4 54.302 4.838 55.402 6 55.816V62H8V56H10V62H12V55.816C13.161 55.402 14 54.302 14 53V50H18V44H14V41C14 39.698 13.161 38.598 12 38.184V36H18V37C18 38.302 18.838 39.402 20 39.816V45.5C20 54.598 27.402 62 36.5 62C44.722 62 51.576 56.035 52.794 48H53C54.654 48 56 46.654 56 45C56 43.346 54.654 42 53 42V37.576C54.763 36.802 56 35.045 56 33V22.383C59.717 20.239 62 16.315 62 12C62 8.59 60.541 5.329 57.997 3.054ZM28 5V31C28 32.654 26.654 34 25 34H24V2H25C26.654 2 28 3.346 28 5ZM2 31V5C2 3.346 3.346 2 5 2H6V30H8V2H22V34H8V31.999H6V34H5C3.346 34 2 32.654 2 31ZM9 49C7.897 49 7 48.103 7 47C7 45.897 7.897 45 9 45C10.102 45 11 45.897 11 47C11 48.103 10.102 49 9 49ZM2 46H5.142C5.058 46.321 5 46.653 5 47C5 47.347 5.058 47.679 5.142 48H2V46ZM12 53C12 53.552 11.552 54 11 54H7C6.448 54 6 53.552 6 53V50H6.382C7.085 50.615 7.994 51 9 51C10.006 51 10.915 50.615 11.618 50H12V53ZM16 48H12.858C12.942 47.679 13 47.347 13 47C13 46.653 12.942 46.321 12.858 46H16V48ZM11.618 44C10.915 43.385 10.006 43 9 43C7.994 43 7.085 43.385 6.382 44H6V41C6 40.448 6.448 40 7 40H11C11.552 40 12 40.448 12 41V44H11.618ZM10 38H8V36H10V38ZM25 36C25.342 36 25.677 35.965 26 35.899V37C26 37.552 25.552 38 25 38H21C20.448 38 20 37.552 20 37V36H25ZM36.5 60C28.505 60 22 53.495 22 45.5V40H24V45.5C24 52.393 29.607 58 36.5 58C42.461 58 47.568 53.758 48.74 48H50.774C49.581 54.907 43.623 60 36.5 60ZM54 45C54 45.552 53.552 46 53 46H47C46.448 46 46 45.552 46 45C46 44.448 46.448 44 47 44H53C53.552 44 54 44.448 54 45ZM51 42H49V38H51V42ZM54.544 20.898L54 21.178V30H52V32H54V33C54 34.654 52.654 36 51 36H49C47.346 36 46 34.654 46 33V32H50V30H46V21.178L45.455 20.899C41.601 18.927 39.459 14.71 40.124 10.403C40.794 6.061 44.461 2.555 48.845 2.066C49.236 2.022 49.627 2 50.014 2C52.48 2 54.807 2.883 56.664 4.544C58.784 6.44 60 9.158 60 12C60 15.767 57.909 19.177 54.544 20.898Z"
          fill="white"
        />
        <path
          d="M15 24C12.794 24 11 25.794 11 28C11 30.206 12.794 32 15 32C17.206 32 19 30.206 19 28C19 25.794 17.206 24 15 24ZM15 30C13.897 30 13 29.103 13 28C13 26.897 13.897 26 15 26C16.102 26 17 26.897 17 28C17 29.103 16.102 30 15 30Z"
          fill="black"
        />
        <path d="M20 6H10V14H20V6ZM18 12H12V8H18V12Z" fill="black" />
        <path d="M16 16H14V18H16V16Z" fill="black" />
        <path d="M16 20H14V22H16V20Z" fill="black" />
        <path d="M51 8H49V10H51V8Z" fill="black" />
        <path d="M48 11H46V13H48V11Z" fill="black" />
        <path d="M51 14H49V16H51V14Z" fill="black" />
        <path d="M54 11H52V13H54V11Z" fill="black" />
      </svg>
    ),
    title: "Solar Water Heater",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clip-path="url(#clip0_814_2158)">
          <path
            d="M80 51.6667C80 37.0733 68.9033 25.02 54.7067 23.4967C52.7633 10.2233 41.3033 0 27.5 0C12.3367 0 0 12.3367 0 27.5067L0.126667 80.0067L6.79333 79.9933L6.66667 27.5C6.66667 16.0133 16.0133 6.66667 27.5 6.66667C37.6467 6.66667 46.12 13.9567 47.96 23.5767C34.0833 25.3967 23.3333 37.3 23.3333 51.6667V56.6667H43.3333V58.3333C43.3333 62.9367 47.0633 66.6667 51.6667 66.6667C56.27 66.6667 60 62.9367 60 58.3333V56.6667H80V51.6667ZM30.0633 50C30.92 38.8267 40.28 30 51.6667 30C63.0533 30 72.4167 38.8267 73.27 50H30.06H30.0633Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_814_2158">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Solar Street Light",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <path
          d="M42 22C42 20.8954 41.1046 20 40 20C38.8954 20 38 20.8954 38 22V58C38 59.1046 38.8954 60 40 60C41.1046 60 42 59.1046 42 58V22Z"
          fill="white"
        />
        <path
          d="M45.3333 60H34.6666C33.9302 60 33.3333 60.597 33.3333 61.3333V64C33.3333 64.7364 33.9302 65.3333 34.6666 65.3333H45.3333C46.0696 65.3333 46.6666 64.7364 46.6666 64V61.3333C46.6666 60.597 46.0696 60 45.3333 60Z"
          fill="white"
        />
        <path
          d="M58 6.66675H22C20.8954 6.66675 20 7.56218 20 8.66675V18.0001C20 19.1047 20.8954 20.0001 22 20.0001H58C59.1046 20.0001 60 19.1047 60 18.0001V8.66675C60 7.56218 59.1046 6.66675 58 6.66675Z"
          fill="white"
        />
        <path d="M20 13.3333H60" stroke="black" />
        <path d="M30 6.66675V20.0001" stroke="black" />
        <path d="M40 6.66675V20.0001" stroke="black" />
        <path d="M50 6.66675V20.0001" stroke="black" />
        <path d="M40 20V26.6667" stroke="#2E3A59" stroke-width="2" />
        <path
          d="M29.9999 32.6666C31.4727 32.6666 32.6666 31.4727 32.6666 29.9999C32.6666 28.5272 31.4727 27.3333 29.9999 27.3333C28.5272 27.3333 27.3333 28.5272 27.3333 29.9999C27.3333 31.4727 28.5272 32.6666 29.9999 32.6666Z"
          fill="#FFC107"
        />
        <path
          d="M39.9999 32.6666C41.4727 32.6666 42.6666 31.4727 42.6666 29.9999C42.6666 28.5272 41.4727 27.3333 39.9999 27.3333C38.5272 27.3333 37.3333 28.5272 37.3333 29.9999C37.3333 31.4727 38.5272 32.6666 39.9999 32.6666Z"
          fill="#FFC107"
        />
        <path
          d="M49.9999 32.6666C51.4727 32.6666 52.6666 31.4727 52.6666 29.9999C52.6666 28.5272 51.4727 27.3333 49.9999 27.3333C48.5272 27.3333 47.3333 28.5272 47.3333 29.9999C47.3333 31.4727 48.5272 32.6666 49.9999 32.6666Z"
          fill="#FFC107"
        />
        <path
          opacity="0.2"
          d="M30 34C32.2091 34 34 32.2091 34 30C34 27.7909 32.2091 26 30 26C27.7909 26 26 27.7909 26 30C26 32.2091 27.7909 34 30 34Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M40 34C42.2091 34 44 32.2091 44 30C44 27.7909 42.2091 26 40 26C37.7909 26 36 27.7909 36 30C36 32.2091 37.7909 34 40 34Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M50 34C52.2091 34 54 32.2091 54 30C54 27.7909 52.2091 26 50 26C47.7909 26 46 27.7909 46 30C46 32.2091 47.7909 34 50 34Z"
          fill="white"
        />
      </svg>
    ),
    title: "Solar High Masts",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clip-path="url(#clip0_814_2173)">
          <path
            d="M71.6667 63.3899H70V43.3899C70 26.8466 56.5433 13.3899 40 13.3899C23.4567 13.3899 10 26.8466 10 43.3899V63.3899H8.33333C3.73667 63.3899 0 67.1266 0 71.7233V79.9999H80V71.7233C80 67.1266 76.2633 63.3899 71.6667 63.3899ZM13.3333 43.3899C13.3333 28.6866 25.2967 16.7233 40 16.7233C54.7033 16.7233 66.6667 28.6866 66.6667 43.3899V63.3899H13.3333V43.3899ZM76.6667 76.6666H3.33333V71.7233C3.33333 68.9666 5.57667 66.7233 8.33333 66.7233H71.6667C74.4233 66.7233 76.6667 68.9666 76.6667 71.7233V76.6666ZM8.37 20.4233L0.53 13.2233L2.78333 10.7699L10.6233 17.9699L8.37 20.4233ZM22.1 10.7533L17.91 1.64993L20.9367 0.256592L25.1267 9.35659L22.1 10.7499V10.7533ZM71.9167 20.2166L69.6067 17.8133L77.1833 10.5266L79.4933 12.9299L71.9167 20.2166ZM57.92 10.7133L54.8533 9.39659L58.7533 0.296592L61.82 1.61326L57.92 10.7133ZM40 30.0566V33.3899C34.4867 33.3899 30 37.8766 30 43.3899H26.6667C26.6667 36.0366 32.6467 30.0566 40 30.0566Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_814_2173">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Solar Emergency Lights",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clip-path="url(#clip0_814_2171)">
          <path
            d="M79.9967 40.4332L70.2142 35.0861L70.2443 35.0327L78.6202 29.0589L28.4285 0.999747C24.3926 -1.17711 19.3243 0.319688 17.1259 4.33671L11.042 15.4577C8.83692 19.4914 10.3303 24.5618 14.3496 26.752L35.7519 38.8597L29.8317 56.5779C29.1468 58.6248 27.2358 59.9982 25.0775 59.9982H3.34099V43.3301H0V80H3.34099V63.3319H25.0808C28.6824 63.3319 31.8664 61.0417 33.0056 57.6347L38.7187 40.5365L60.4986 52.8576L62.4865 49.224L72.269 54.5711L80 40.4365L79.9967 40.4332ZM59.189 48.2839L15.9766 23.8417C13.5511 22.5216 12.6557 19.4747 13.9787 17.0578L20.0626 5.93685C20.9714 4.27337 22.7054 3.32995 24.4761 3.32995C25.2712 3.32995 26.0764 3.51997 26.8181 3.92L72.3992 29.4022L67.9925 32.5458L59.1923 48.2872L59.189 48.2839ZM64.0835 46.2937L68.6139 38.0097L75.4663 41.7533L70.9359 50.034L64.0835 46.2937Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_814_2171">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Solar CCTV Systems",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <path
          d="M76.6933 8.83061e-06C76.2589 -0.000465435 75.8287 0.0847116 75.4273 0.250667C75.0259 0.416622 74.6612 0.660097 74.354 0.967162C74.0468 1.27423 73.8031 1.63885 73.637 2.04018C73.4708 2.4415 73.3855 2.87165 73.3857 3.306L73.3866 3.32297L54.0583 22.6513C53.8916 22.496 53.6711 22.4114 53.4433 22.4153C53.2155 22.4192 52.9981 22.5113 52.8367 22.6722L32.8116 42.6973C32.2135 42.6926 31.6204 42.807 31.067 43.0338C30.5136 43.2606 30.0108 43.5953 29.5881 44.0185L2.5738 71.0327C2.40842 71.1981 2.31551 71.4224 2.31551 71.6563C2.31551 71.8902 2.40842 72.1145 2.5738 72.2799L2.89357 72.5996L0.258313 75.2349C0.176418 75.3168 0.111455 75.414 0.0671337 75.521C0.0228123 75.628 0 75.7427 0 75.8585C0 75.9743 0.0228123 76.089 0.0671337 76.196C0.111455 76.303 0.176418 76.4002 0.258313 76.4821L3.51716 79.7409C3.68256 79.9063 3.90687 79.9992 4.14075 79.9992C4.37464 79.9992 4.59895 79.9063 4.76435 79.7409L7.3996 77.1057L7.71936 77.4254C7.88476 77.5908 8.10907 77.6837 8.34296 77.6837C8.57684 77.6837 8.80115 77.5908 8.96655 77.4254L35.9808 50.4112C36.4039 49.9884 36.7386 49.4857 36.9655 48.9323C37.1923 48.3788 37.3067 47.7858 37.3019 47.1877L57.327 27.1625C57.488 27.0012 57.5801 26.7838 57.584 26.556C57.5879 26.3281 57.5033 26.1077 57.3479 25.941L76.6763 6.61262L76.6933 6.6135C77.5703 6.6135 78.4113 6.26511 79.0315 5.64498C79.6516 5.02484 80 4.18376 80 3.30675C80 2.42975 79.6516 1.58866 79.0315 0.968525C78.4113 0.348389 77.5703 8.83061e-06 76.6933 8.83061e-06ZM35.2531 48.4364L31.5629 44.7462C32.0793 44.4915 32.6625 44.405 33.2306 44.4988C33.7986 44.5925 34.3231 44.8619 34.7302 45.269C35.1374 45.6761 35.4067 46.2006 35.5005 46.7687C35.5943 47.3367 35.5078 47.92 35.2531 48.4364ZM4.14075 77.8701L2.12909 75.8585L4.14075 73.8468L6.15242 75.8585L4.14075 77.8701ZM8.34296 75.5546L4.44458 71.6563L30.2116 45.8892L34.11 49.7876L8.34296 75.5546ZM36.8183 45.1769C36.3841 44.3148 35.6844 43.6151 34.8223 43.1809L53.4603 24.543L55.4563 26.539L36.8183 45.1769ZM56.1031 24.6914L55.3078 23.8961L73.9921 5.21182C74.21 5.52023 74.479 5.78917 74.7874 6.00707L56.1031 24.6914ZM76.6933 4.84976C76.3875 4.84935 76.0887 4.75812 75.8348 4.58764C75.581 4.41715 75.3835 4.17511 75.2674 3.8922C75.1513 3.6093 75.1219 3.29829 75.1828 2.99863C75.2438 2.69898 75.3924 2.42419 75.6098 2.20912C75.8272 1.99405 76.1035 1.8484 76.4038 1.79065C76.7041 1.73291 77.0148 1.76566 77.2964 1.88476C77.5781 2.00386 77.818 2.20393 77.9858 2.4596C78.1535 2.71527 78.2415 3.01501 78.2387 3.32079C78.235 3.728 78.0704 4.11723 77.7809 4.40364C77.4915 4.69005 77.1005 4.8504 76.6933 4.84976Z"
          fill="white"
        />
      </svg>
    ),
    title: "Solar Security Sticks",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clip-path="url(#clip0_814_2177)">
          <path
            d="M41.6667 21.75V0H38.3333V21.75C17.0533 22.63 0 40.0633 0 61.4333V66.6667H26.6667C26.6667 74.02 32.6467 80 40 80C47.3533 80 53.3333 74.02 53.3333 66.6667H80V61.4333C80 40.0667 62.9467 22.6267 41.6667 21.75ZM40 76.6667C34.4867 76.6667 30 72.18 30 66.6667H50C50 72.18 45.5133 76.6667 40 76.6667ZM76.6667 63.3333H3.33333V61.4333C3.33333 41.3433 19.7833 25 40 25C60.2167 25 76.6667 41.3433 76.6667 61.4333V63.3333Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_814_2177">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "LED Lightning Solutions",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <path
          d="M55.3334 10H24.6667C20.2485 10 16.6667 13.5817 16.6667 18V62C16.6667 66.4183 20.2485 70 24.6667 70H55.3334C59.7517 70 63.3334 66.4183 63.3334 62V18C63.3334 13.5817 59.7517 10 55.3334 10Z"
          fill="#F8FAFC"
          stroke="black"
          stroke-width="3"
        />
        <path
          d="M52.6666 3.33325H27.3333C25.1241 3.33325 23.3333 5.12411 23.3333 7.33325V9.33325C23.3333 11.5424 25.1241 13.3333 27.3333 13.3333H52.6666C54.8757 13.3333 56.6666 11.5424 56.6666 9.33325V7.33325C56.6666 5.12411 54.8757 3.33325 52.6666 3.33325Z"
          fill="black"
        />
        <path
          opacity="0.7"
          d="M52.6666 20H27.3333C25.1241 20 23.3333 21.7909 23.3333 24V36C23.3333 38.2091 25.1241 40 27.3333 40H52.6666C54.8757 40 56.6666 38.2091 56.6666 36V24C56.6666 21.7909 54.8757 20 52.6666 20Z"
          fill="#38BDF8"
        />
        <path d="M26.6667 46.6667H53.3334" stroke="#1E293B" stroke-width="2" />
        <path d="M26.6667 52H53.3334" stroke="#1E293B" stroke-width="2" />
        <path
          d="M44.6666 56.6667H35.3333C34.2287 56.6667 33.3333 57.5622 33.3333 58.6667V60.0001C33.3333 61.1047 34.2287 62.0001 35.3333 62.0001H44.6666C45.7712 62.0001 46.6666 61.1047 46.6666 60.0001V58.6667C46.6666 57.5622 45.7712 56.6667 44.6666 56.6667Z"
          fill="#1E293B"
        />
        <path
          d="M39.9999 68.0001C41.4727 68.0001 42.6666 66.8062 42.6666 65.3334C42.6666 63.8607 41.4727 62.6667 39.9999 62.6667C38.5272 62.6667 37.3333 63.8607 37.3333 65.3334C37.3333 66.8062 38.5272 68.0001 39.9999 68.0001Z"
          fill="#38BDF8"
        />
        <path
          d="M40.0001 68C36.6668 73.3333 43.3334 73.3333 40.0001 78.6667C36.6668 73.3333 43.3334 73.3333 40.0001 68Z"
          fill="white"
        />
      </svg>
    ),
    title: "Water Purifier Machines",
  },
];

const AboutProduct = () => {
  return (
    <section className="aboutproduct-section">
      <div className="aboutproduct-container">
        {/* HEADING */}

        <h2 className="aboutproduct-heading">Our Product Range</h2>

        <p className="aboutproduct-subtext">
          We offer a wide range of advanced solar and energy-efficient products:
        </p>

        {/* PRODUCT GRID */}

        <div className="aboutproduct-grid">
          {products.map((item, index) => (
            <div className="aboutproduct-card" key={index}>
              <div className="aboutproduct-icon">{item.icon}</div>

              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutProduct;
